import {
  Edit,
  Box,
  TextField,
  FormControl,
  FormControlLabel,
  FormHelperText,
  FormLabel,
  Radio,
  RadioGroup,
} from "@pankod/refine-mui";
import { Controller, useForm } from "@pankod/refine-react-hook-form";

import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";

const schema = Yup.object({
  tier_subscription_id: Yup.number().required(),
  is_active: Yup.boolean().required(),
  duration: Yup.number().required(),
});

interface formDataType {
  tier_subscription_id: number;
  is_active: boolean;
  duration: number;
}

export const TierSubscriptionEdit = () => {
  const {
    saveButtonProps,
    register,
    control,
    formState: { errors },
  } = useForm<formDataType>({ resolver: yupResolver(schema) });

  return (
    <Edit canDelete={false} saveButtonProps={saveButtonProps}>
      <Box
        component="form"
        sx={{ display: "flex", flexDirection: "column" }}
        autoComplete="off"
      >
        <TextField
          {...register("tier_subscription_id")}
          required
          error={!!(errors as any)?.tier_subscription_id}
          helperText={(errors as any)?.tier_subscription_id?.message}
          margin="normal"
          fullWidth
          InputLabelProps={{ shrink: true }}
          type="number"
          label="Tier_subscription_id"
          name="tier_subscription_id"
          disabled
        />
         <TextField
          {...register("tier_name", {
            required: "This field is required",
          })}
          required
          error={!!(errors as any)?.tier_name}
          helperText={(errors as any)?.tier_name?.message}
          margin="normal"
          fullWidth
          InputLabelProps={{ shrink: true }}
          type="text"
          label="Tier_name"
          name="tier_name"
          disabled
        />
        <TextField
          {...register("user_id")}
          required
          error={!!(errors as any)?.user_id}
          helperText={(errors as any)?.user_id?.message}
          margin="normal"
          fullWidth
          InputLabelProps={{ shrink: true }}
          type="number"
          label="User_id"
          name="user_id"
          disabled
        />
      </Box>
    </Edit>
  );
};
